import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Compiler, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { LoginData } from '../service/modal/login';
import { Plan } from '../service/modal/plan';
import { LoginService } from '../service/apiservice/login.service';
import { Transaction } from '../service/modal/transaction';
import { PaymentService } from '../service/apiservice/payment.service';
import { PaymentDetails, updatePlanRequestDto } from '../service/modal/payment';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { User, SessionUser } from '../service/modal/user';

import { NgNavigatorShareService } from 'ng-navigator-share';
import { UploadFileS3BucketService } from '../service/apiservice/uploadFileS3Bucket.service';
import { UtilFunctions } from '../util-functions';
import { ShareButtons } from '@ngx-share/buttons';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { PlanDataService } from '../service/apiservice/planData.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { DoctorService } from '../service/apiservice/doctor.service';
import { PromoCodeService } from '../service/apiservice/promocode.service';
import { PromoCode } from '../service/modal/promocode';
import { MdhlSettingService } from '../service/apiservice/mdhlSetting.service';
import { MdhlSetting } from '../service/modal/mdhlSetting';
import { DomSanitizer } from '@angular/platform-browser';






declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent implements OnInit {

  currentRow: any;
  imgurl: any;

  loggedUserInfo: User;
  plandata;
  // planList: Plan[] = [{
  //   "plan_id": 2,
  //   "plan_name": "1 GB",
  //   "plan_type": "1 Month",
  //   "amount": 500
  // },
  // {
  //   "plan_id": 3,
  //   "plan_name": "1 GB",
  //   "plan_type": "Life time",
  //   "amount": 2000
  // }
  // ]
  planList: Plan[] = new Array;
  disableSubcriptionbutton: boolean;
  radioBtnId;
  planChooseData;
  firstname;
  lastname;
  referralCode;
  genratedOtp;
  otpCheck;
  enterdminlenght;

  form: FormGroup;
  selectedFiles: File[];
  userObj: User;
  switchProfileStr;

  @ViewChild('addForm') addForm: any;

  @ViewChild('topdiv') topdiv: ElementRef;
  @ViewChild('AddCloseForm') addCloseForm: ElementRef;
  addTransaction: Transaction = new Transaction();
  profileImgCharString: String[] = ['A.png', 'B.png', 'C.png', 'D.png', 'E.png', 'F.png', 'G.png', 'H.png', 'I.png', 'J.png', 'K.png', 'L.png', 'M.png', 'N.png', 'O.png', 'P.png', 'Q.png', 'R.png', 'S.png', 'T.png', 'U.png', 'V.png', 'W.png', 'X.png', 'Y.png', 'Z.png'];
  //create funct
  setClickedRow: Function;
  selectedRow: Number;
  enterd10digitreferalcode = '';

  refferalCodeShareMessage = "Hey, join MDHL - My Digital Health Locker to 'Store,Access and Secure Your Medical Data Digitally' And Get 50 MB Data Storage Extra using My referral code ";

  HealthCardText = "";
  submitted = false;
  hcBackSideForm: FormGroup;
  isHealthCardBackSideForm = false;

  promoCodeForm: FormGroup;
  promoCodesubmitted = false;
  promoCodeYes: boolean = false;
  promoCode: PromoCode = new PromoCode;
  updatePlanRequestDto: updatePlanRequestDto = new updatePlanRequestDto;
  paymentData: PaymentDetails = new PaymentDetails;
  pymentBackBtn: boolean = false;
  mdhlSettingInfo: MdhlSetting = new MdhlSetting;
  healthCardTypeFormForPlan: FormGroup;
  planExpire: boolean = false;

  healthCardChargespayment;
  healthCardType;

  //ckEditor
  ckeConfig: any;
  healthCardBackSidePreviewObj: any;
  @ViewChild("myckeditor") ckeditor: any;

  


  constructor(private spinner: NgxSpinnerService, private _compiler: Compiler, private uploadService: UploadFileS3BucketService, private fb: FormBuilder, private _paymentService: PaymentService, private router: Router, private global: Globals, private _loginService: LoginService, private ngNavigatorShareService: NgNavigatorShareService
    , private sanitized: DomSanitizer, private mdhlSettingService: MdhlSettingService, private promCodeService: PromoCodeService, private planDataService: PlanDataService, private doctorservice: DoctorService, private formBuilder: FormBuilder) {
    this.disableSubcriptionbutton = false;

  }
  ckEditorConfig() {

    this.ckeConfig = {
      // contentsCss : './topnav.component.css',
      // contentsCss : 'assets/js/ckeditor.css',
      enterMode: 2,
      allowedContent: true,
      forcePasteAsPlainText: true,
      font_names: 'Arial;Comic Sans Ms;Times New Roman;Verdana;Tahoma',
      toolbarGroups: [
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
        { name: 'forms', groups: ['forms'] },
        '/',
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
        { name: 'links', groups: ['links'] },
        { name: 'insert', groups: ['insert'] },
        '/',
        { name: 'styles', groups: ['styles'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'tools', groups: ['tools'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] }
      ],
      removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CopyFormatting,RemoveFormat,CreateDiv,Blockquote,BidiLtr,BidiRtl,Language,Unlink,Anchor,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About'
    };
  }
  ngOnInit() {
    debugger
    localStorage.setItem("Active Route", this.router.url);

    
    this.ckEditorConfig();
    // this.ckeConfig = {
    //   allowedContent: false,
    //   extraPlugins: 'divarea',
    //   forcePasteAsPlainText: true
    // };

    this.setClickedRow = function (index) {
      this.selectedRow = index;
    }
    this.global.afterRefreshPageSetToken();
    this.loadHealtCardBakSideForm();
    this.getUserInfoById();
    this.getSettingInfo();
    this.loadHealthCardTypeFormForPlan();
    // this.getUserPlanInfo();
    // this.getPlanList();
    // if (this.global.loggedUser.user.doctorStatusActive == true) {
    //    info_noti("Your Account  Deactivated ")
    //   this.router.navigate(['login']);
    //   this.global.loggedUser = new LoginData();
    //   this.global.sharehealthCard = "";
    //   this.global.switchProfileStr = "";
    //   this.global.refreshCount = 0;
    //   this.router.navigate(['login']);
    //   localStorage.clear();
    // }
    $(document).ready(function () {
      $("#refrralMsg").toggle();
      $("#webCam").toggle();
      $("#snapshot").toggle();
    });


    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
      if (!$(this).next().hasClass('show')) {
        $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
      }
      var $subMenu = $(this).next('.dropdown-menu');
      $subMenu.toggleClass('show');
      $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
        $('.dropdown-submenu.show').removeClass('show');
      });
      return false;
    });

    if(this.global.buyNowButtonClick){
      this.global.buyNowButtonClick=false;
  
      $("#promoCodeModel").modal("show");
     localStorage.removeItem('BuyNowBtnStatus');  
  
     }

  }
  getUserInfoById() {
    this._loginService.getUserById(this.global.loggedUser.user.user_reg_id).subscribe(response => {
      this.loggedUserInfo = response;
      // console.log(this.loggedUserInfo);
      this.refferalCodeShareMessage = this.refferalCodeShareMessage + this.loggedUserInfo.userRefCode + "\n here:\t";
      if (this.loggedUserInfo != undefined) {
        // if (this.loggedUserInfo.role === 'doctor') {
        if (this.global.loggedUser.user.role == 'doctor' || this.global.loggedUser.user.role == 'hospital' || this.global.loggedUser.user.role == 'subagent' || this.global.loggedUser.user.role == 'franchise' || this.global.loggedUser.user.role == 'school' || this.global.loggedUser.user.role == 'corporate' || this.global.loggedUser.user.role == 'other') {


          $("#switchProfileUser").toggle();
          $("#patientIconsOnly").toggle();
          if (this.global.switchProfileStr == "") {
            if (this.global.refreshCount == 1) {

              if (this.router.url.includes("/doctordashboard")) {
                $("#patientIconsOnly").hide();
                $("#switchProfileUser").show();
                this.global.switchProfileStr = 'patient';
                this.switchProfileStr = 'patient';
                if (window.innerWidth <= 600) {
                  // $("#wrapper").toggleClass("toggled");
                } else {
                  $("#wrapper").toggleClass("toggled");
                }
              } else {
                $("#patientIconsOnly").show();
                $("#switchProfileUser").show();
                this.global.switchProfileStr = this.global.loggedUser.user.role;
                this.switchProfileStr = this.global.loggedUser.user.role;
              }
            } else if (this.global.refreshCount == 0) {
              if (this.router.url.includes("/doctordashboard")) {
                $("#switchProfileUser").show();
                $("#patientIconsOnly").hide();
                this.global.switchProfileStr = 'patient';
                this.switchProfileStr = 'patient';
                if (window.innerWidth <= 600) {
                  // $("#wrapper").toggleClass("toggled");
                } else {
                  $("#wrapper").toggleClass("toggled");
                }
              } else {
                $("#patientIconsOnly").show();
                $("#switchProfileUser").show();
                this.global.switchProfileStr = this.global.loggedUser.user.role;
                this.switchProfileStr = this.global.loggedUser.user.role;
              }
            }
          }
          else if (this.global.switchProfileStr == 'patient') {
            $("#switchProfileUser").show();
            $("#patientIconsOnly").hide();
            this.global.switchProfileStr = 'patient';
            this.switchProfileStr = 'patient';
            if (window.innerWidth <= 600) {
              // $("#wrapper").toggleClass("toggled");
            } else {
              $("#wrapper").toggleClass("toggled");
            }
          } else if (this.global.loggedUser.user.role == 'doctor' || this.global.loggedUser.user.role == 'hospital' || this.global.loggedUser.user.role == 'subagent' || this.global.loggedUser.user.role == 'franchise' || this.global.loggedUser.user.role == 'school' || this.global.loggedUser.user.role == 'corporate' || this.global.loggedUser.user.role == 'other') {
            //  else if (this.global.switchProfileStr == 'doctor') {
            $("#switchProfileUser").show();
            $("#patientIconsOnly").show();
            this.global.switchProfileStr = this.global.loggedUser.user.role;
            this.switchProfileStr = this.global.loggedUser.user.role;
          }
        }
        else {
          $("#switchProfileUser").toggle();
          $("#patientIconsOnly").toggle();
          if (this.global.refreshCount == 1) {
            $("#patientIconsOnly").show();
            $("#switchProfileUser").hide();
          } else {
            if (this.global.refreshCount == 0) {
              $("#patientIconsOnly").show();
              $("#switchProfileUser").hide();
            }
          }
        }
        // if (this.loggedUserInfo.role === 'patient'){
        //   $("#patientIconsOnly").show();
        //   $("#switchProfileUser").hide().attr("formnovalidate");
        // } 



        // this.pogressvalue=100;

        this.firstname = this.loggedUserInfo.firstName.charAt(0).toUpperCase() + this.loggedUserInfo.firstName.slice(1);
        if (this.lastname != null) {
          this.lastname = this.loggedUserInfo.lastName.charAt(0).toUpperCase() + this.loggedUserInfo.lastName.slice(1);
        }
      }


      this.getUserPlanInfo();

    }, err => { });
  }
  getUserPlanInfo() {
    this._loginService.getUserPlanInfoById(this.global.loggedUser.user.user_reg_id).subscribe(response => {
      this.plandata = response;
      if (this.plandata.per != null) {
        if (this.plandata.per >= 90 && this.plandata.per < 100) {
          //  info_noti("your pack");
          $("#subscriptionModel").modal("show");
          // 
          //
        } else if (this.plandata.per == 100) {
          $("#planExpireModel").modal("show");
          this.planExpire = true;
          $(document).ready(function () {
            $("#planExpireModel").modal({ backdrop: 'static', keyboard: false });
          });
        } else if (this.plandata.planStatus == 'Expired') {
          $("#planExpireModel").modal("show");
          this.planExpire = true;
          $(document).ready(function () {
            $("#planExpireModel").modal({ backdrop: 'static', keyboard: false });
          });
        }
      }
      // this.getPlanList();
    }, err => { });
  }


  getPlanList() {
    debugger;
    this.planDataService.GetPlanData().subscribe(response => {
      Object.assign(this.planList, response);
    }, err => { });

  }
  getSettingInfo() {
    debugger;
    this.mdhlSettingService.getMdhlSetting().subscribe(response => {
      Object.assign(this.mdhlSettingInfo, response);
    }, err => { });
  }

  SearchBox(event) {
    if (this.router.url == "/dashboard/pendingrequest") {
      $('#pendingdatatable').DataTable().search(event.target.value).draw();
      $('#pendingdatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url == "/dashboard/approvedhc") {
      $('#approvedDatatableTest').DataTable().search(event.target.value).draw();
      $('#approvedDatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url == "/dashboard/staredhc") {
      $('#staredDatatable').DataTable().search(event.target.value).draw();
      $('#staredDatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url == "/dashboard/showhidden") {
      $('#hiddenDatatable').DataTable().search(event.target.value).draw();
      $('#hiddenDatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url == "/dashboard/trashhc") {
      $('#trashDatatable').DataTable().search(event.target.value).draw();
      $('#trashDatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url.includes("/dashboard/specificationhc")) {
      $('#specDatatable').DataTable().search(event.target.value).draw();
      $('#specDatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url.includes("/dashboard/remarkhc")) {
      $('#remarkDatatable').DataTable().search(event.target.value).draw();
      $('#remarkDatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url.includes("/dashboard/subjecthc")) {
      $('#subjectDatatable').DataTable().search(event.target.value).draw();
      $('#subjectDatatable_IsMobile').DataTable().search(event.target.value).draw();
    }
    else if (this.router.url == "/dashboard/getotpallapproved") {
      $('#allApprovedDatatable').DataTable().search(event.target.value).draw();
      $('#allApprovedDatatable_IsMobile').DataTable().search(event.target.value).draw();
    } else if (this.router.url == "/doctordashboard/doctorpage") {
      $('#patientDatatable').DataTable().search(event.target.value).draw();

      // $("#patientDatatable_IsMobile").DataTable().search(event.target.value).draw();
    } else if (this.router.url == "/dashboard/sentemail") {
      $('#SendEmailDatatable').DataTable().search(event.target.value).draw();
      $('#SendEmailDatatable_IsMobile').DataTable().search(event.target.value).draw();
    } else if (this.router.url == "/dashboard/specification") {
      var input, filter, cards, cardContainer, h5, title, i;
      filter = event.target.value.toUpperCase();
      cardContainer = document.getElementById("specificationSearch");
      cards = cardContainer.getElementsByClassName("card");
      for (i = 0; i < cards.length; i++) {
        title = cards[i].querySelector(".card-body p.card-text");
        if (title.innerText.toUpperCase().indexOf(filter) > -1) {
          cards[i].style.display = "";
        } else {
          cards[i].style.display = "none";
        }
      }
    } else if (this.router.url == "/dashboard/remark") {
      var input, filter, cards, cardContainer, h5, title, i;
      filter = event.target.value.toUpperCase();
      cardContainer = document.getElementById("remarkSearch");
      cards = cardContainer.getElementsByClassName("card");
      for (i = 0; i < cards.length; i++) {
        title = cards[i].querySelector(".card-body p.card-text");
        if (title.innerText.toUpperCase().indexOf(filter) > -1) {
          cards[i].style.display = "";
        } else {
          cards[i].style.display = "none";
        }
      }
    } else if (this.router.url == "/dashboard/subject") {
      var input, filter, cards, cardContainer, h5, title, i;
      filter = event.target.value.toUpperCase();
      cardContainer = document.getElementById("subjectSearch");
      cards = cardContainer.getElementsByClassName("card");
      for (i = 0; i < cards.length; i++) {
        title = cards[i].querySelector(".card-body p.card-text");
        if (title.innerText.toUpperCase().indexOf(filter) > -1) {
          cards[i].style.display = "";
        } else {
          cards[i].style.display = "none";
        }
      }

    }
  }

  // checkboxChanged(event, obj) {
  //   debugger;
  //   if (event.value) {
  //     this.disableSubcriptionbutton = true;
  //     this.selectedPlanList.push(event.value);
  //     this.planChooseData = obj;
  //   }
  //   else {
  //     this.disableSubcriptionbutton = false;
  //     this.selectedPlanList.splice(this.selectedPlanList.indexOf(event.target.value), 1);
  //   }
  //   this.selectedPlanList = Array.from(new Set(this.selectedPlanList));
  // }

  logout() {
    // this.global.loggedUser = new LoginData();
    this.global.sharehealthCard = "";
    this.global.switchProfileStr = "";
    this.global.refreshCount = 0;
    this.global.loginCount = 0;
    this._compiler.clearCache();
    UtilFunctions.clearLocalStorage();
    this.router.navigate(['login']);

  }

  changePassword() {
    this.router.navigate(['dashboard/changePassword']);
  }
  checkOtp(opt) {
    // this.loginotp=opt;
    if (opt != "") {
      this._loginService.CheckOtp(this.genratedOtp, opt).subscribe((response) => {
        this.otpCheck = response;
        if (this.otpCheck === 'Otp Not Match' || this.otpCheck === 'Expired Otp') {
          info_noti("Otp Not Match")
        }
      }, error => {
      });
    }

  }

  resendOtp(status) {
    this._loginService.GenerateOtp(this.global.loggedUser.user.mobileNumber, this.global.loggedUser.user.firstName, status).subscribe((response) => {
      this.genratedOtp = response.otp_id;
    }, error => {

    });
  }


  addTransctionPassword() {
    this.router.navigate(['dashboard/transctionPassword']);
  }



  checkReferralCode(referral) {
    this.referralCode = "";
    this._loginService.checkReferralCode(referral).subscribe((reponse) => {
      if (reponse == 'Vaild Referral Code') {
        this.referralCode = reponse;
      } else {
        this.referralCode = reponse;
      }


    }, err => { });
  }
  changeReferralCode(referralcode) {

    if (referralcode.length >= 5 && referralcode.length == 10) {
      this.spinner.show();
      this._loginService.changeReferralCode(referralcode).subscribe((reponse) => {
        if (reponse != null) {
          this.spinner.show();
          info_noti("Referral Code Change Successfully");
          $("#changeReferralCodeModal").modal("hide");
          $("body").removeClass('modal-open');
          $('.modal-backdrop').remove();

          // this.global.loggedUser.user = new User;
          // Object.assign(this.global.loggedUser.user, reponse);
          // UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
          console.log(this.global.loggedUser);
          this.global.loggedUser.user = new SessionUser;
          Object.assign(this.global.loggedUser.user, reponse);
          UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
          window.location.reload();

        } else {
          info_noti("Referral Code Not  Change Successfully");

        }


      }, err => {
        this.spinner.hide();
      });
    }
  }


  genrateOtpForMobilenoChange() {
    this.otpCheck = "";
    $('#otpchangemobileno').val("");
    $('#mobileno').val("");
    this._loginService.GenerateOtp(this.global.loggedUser.user.mobileNumber, this.global.loggedUser.user.firstName, 'Otp Change Mobileno').subscribe((response) => {
      this.genratedOtp = response.otp_id;
    }, error => {
    });
  }

  changeMobileNo(mobileno) {
    //disable the submit button
    this.spinner.show();
    if (mobileno.length == 10) {
      this._loginService.changeMobileno(mobileno).subscribe((reponse) => {
        this.spinner.hide();
        $("#changeMobileNoModal").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        $('otpchangemobileno').val("");
        $('mobileno').val("");

        // this.global.loggedUser.user = new User;
        // Object.assign(this.global.loggedUser.user, reponse);
        Object.assign(this.global.loggedUser, reponse);
        console.log(this.global.loggedUser);
        info_noti("Mobile Number Change Successfully. Your EmailId is: " + this.global.loggedUser.user.emailAddress);
        UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
        UtilFunctions.setLocalStorage('isLoggedIn', "true");
        window.location.reload();
      }, err => {
        this.spinner.hide();
        info_noti("Mobile Number Not Change Successfully");
      });
    }


  }
  uploadProfile() {
    $("#fileLoader").click();
  }
  profileOpen() {
    this.router.navigate(['dashboard/profile']);
  }

  async shareUs() {
    try {
      const sharedResponse = await this.ngNavigatorShareService.share({
        title: '`Web Articles and Tutorials',
        text: 'Check out my blog — its worth looking.',
        url: 'https://mdhl.in'
      });
      console.log(sharedResponse);
    } catch (error) {
      console.log('You app is not shared, reason: ', error);
    }

  }
  onlyDigitEnter(event) {
    console.log("amount digit only")
    var mbileno = event.target.value;
    // console.log(mbileno);
    if (mbileno.length != 10) {
      $("#changemobilenobtn").attr("disabled", true);
    } else {
      $("#changemobilenobtn").attr("disabled", false);
    }


    $(document).ready(function () {

      $("#mobileno").keypress(function (event) {

        if (event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57)) {

          $("#errmsg").html("Digits Only").show().fadeOut("slow");
          return false;
        }
      });
    });
  }
  enterdMinlenght(referalcode): boolean {
    console.log(referalcode);
    if (referalcode.length >= 5 && referalcode.length == 10) {
      this.referralCode = '';
      this.enterdminlenght = '';
      // if (referalcode.length >= 5 && referalcode.length == 10) {
      this.enterd10digitreferalcode = '';
      $("#refrralMsg").hide();
      $("#changeReferralCodeBtn").attr("disabled", false);
      this.referralCode = "";
      this._loginService.checkReferralCode(referalcode).subscribe((reponse) => {
        if (reponse == 'Vaild Referral Code') {
          this.referralCode = reponse;
          return false
        } else {
          this.referralCode = reponse;
          // return true
        }
      }, err => {
        alert(err)
      });
    } else {
      this.enterdminlenght = "less";
      $("#refrralMsg").toggle();
      this.referralCode = '';
      this.enterd10digitreferalcode = '';
      $("#changeReferralCodeBtn").attr("disabled", true);
      return false

    }


  }

  onFileChange(event) {



    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFiles = event.target.files;
      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.imgurl = reader.result;
      }
    }

  }
  changeProfilePic() {
    this.spinner.show();
    if (this.webcamImage != null) {
      this.selectedFiles = new Array;
      var bytearray = this.base64ToByteArray(this.webcamImage.imageAsBase64);
      var file = new File([new Blob(bytearray)], "profile", { type: "image/jpeg" });
      this.selectedFiles[0] = file;
    }

    if (this.selectedFiles.length > 0) {

      this.uploadService.uploadfile(this.selectedFiles, "profileImg");
    }
    setTimeout(() => {
      if (Globals.attachmentStatus == true) {


        var path = "https://mdhl.s3.ap-south-1.amazonaws.com/" + this.global.loggedUser.user.user_reg_id + "/profileImg." + "jpeg";
        this.userObj = new User();
        this.userObj.user_reg_id = this.global.loggedUser.user.user_reg_id;
        this.userObj.profileImgPath = path;
        this._loginService.uploadProfileImg(this.userObj).subscribe((response) => {
          if (response != null) {
            this.spinner.hide();

            // this.global.loggedUser.user = new User;
            // Object.assign(this.global.loggedUser.user, response);
            // UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));

            console.log(this.global.loggedUser);
            this.global.loggedUser.user = new SessionUser;
            Object.assign(this.global.loggedUser.user, response);
            UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
            window.location.reload();
            info_noti("Upload Profile Image Successfully...");
            this.selectedFiles = new Array;
            this.webcamImage = null;
            Globals.attachmentStatus = false;
            $("#changeProfilePicModal").modal("hide");
            $("body").removeClass('modal-open');
            $('.modal-backdrop').remove();

          }
        }, err => { });
      } else {
        info_noti("Please Wait For Upload Profile Img")
        this.spinner.hide();
        return false;

      }
    }, 5000);


  }




  switchProfile(profilevalues) {
    if (profilevalues == 'patient') {

      this.global.switchProfileStr = 'doctor';
      this.switchProfileStr = 'doctor';
      this.router.navigate(['/dashboard']);
    } else if (profilevalues == 'doctor') {
      this.global.switchProfileStr = 'patient';
      this.switchProfileStr = 'patient';
      this.router.navigate(['/doctordashboard']);
    } else if (profilevalues == 'hospital') {
      this.global.switchProfileStr = 'patient';
      this.switchProfileStr = 'patient';
      this.router.navigate(['/doctordashboard']);
    } else if (profilevalues == 'subagent') {
      this.global.switchProfileStr = 'patient';
      this.switchProfileStr = 'patient';
      this.router.navigate(['/doctordashboard']);
    } else if (profilevalues == 'franchise') {
      this.global.switchProfileStr = 'patient';
      this.switchProfileStr = 'patient';
      this.router.navigate(['/doctordashboard']);
    } else if (profilevalues == 'other') {
      this.global.switchProfileStr = 'patient';
      this.switchProfileStr = 'patient';
      this.router.navigate(['/doctordashboard']);
    } else if (profilevalues == 'school') {
      this.global.switchProfileStr = 'patient';
      this.switchProfileStr = 'patient';
      this.router.navigate(['/doctordashboard']);
    } else if (profilevalues == 'corporate') {
      this.global.switchProfileStr = 'patient';
      this.switchProfileStr = 'patient';
      this.router.navigate(['/doctordashboard']);
    }
  }
  deleteProfilePic() {
    var firstletter = this.global.loggedUser.user.firstName.charAt(0);
    var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
    for (let i = 0; i < this.profileImgCharString.length; i++) {
      console.log(this.profileImgCharString[i].charCodeAt(0))
      var first = this.profileImgCharString[i].split(".")[0];
      if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase().toString()) {
        profileImgPath = profileImgPath + this.profileImgCharString[i];
        break;
      }
    }

    this.userObj = new User();
    this.userObj.user_reg_id = this.global.loggedUser.user.user_reg_id;
    this.userObj.profileImgPath = profileImgPath;


    this._loginService.uploadProfileImg(this.userObj).subscribe((response) => {
      if (response != null) {
        info_noti("Profile Image Deleted Successfully...");
        // this.global.loggedUser.user = new User;
        // Object.assign(this.global.loggedUser.user, response);
        // UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
        console.log(this.global.loggedUser);
        this.global.loggedUser.user = new SessionUser;
        Object.assign(this.global.loggedUser.user, response);
        UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
        window.location.reload();
        this.selectedFiles = new Array;
        $("#changeProfilePicModal").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
    }, err => { });
  }

  base64ToByteArray(base64String) {
    try {
      var sliceSize = 1024;
      var byteCharacters = atob(base64String);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return byteArrays;
    } catch (e) {
      console.log("Couldn't convert to byte array: " + e);
      return undefined;
    }
  }


  public seconds: number;
  private trigger: Subject<void> = new Subject<void>();

  // latest snapshot
  public webcamImage: WebcamImage = null;
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info("received webcam image", webcamImage);
    this.webcamImage = webcamImage;
    $("#webCam").hide();
    $("#snapshot").show();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  openWebCam() {
    this.imgurl = "";
    $("#snapshot").hide();
    $("#webCam").show();
    $("#takephoto").attr("disabled", true);

    // this.triggerSnapshot();
  }
  uploadPicHideWebCam() {
    $("#snapshot").hide(); false
    $("#webCam").hide();
    $("#takephoto").attr("disabled", false);
  }
  changeprofilePicClose() {
    this.imgurl = "";
    this.webcamImage = null;
    $("#snapshot").hide();
    $("#webCam").hide();
    $("#takephoto").attr("disabled", false);
  }

  selectRow(event: any, data: any) {
    // debugger;
    // this.currentRow = data.plan_id;
    // this.disableSubcriptionbutton = true;
    // this.selectedPlanList.push(event.value);
    // this.planChooseData = data;
  }

  changeRefrralCodeEnter(referralcode) {
    if (referralcode.length >= 5 && referralcode.length == 10) {
      this.referralCode = '';
      this.enterdminlenght = '';
      // if (referalcode.length >= 5 && referalcode.length == 10) {
      this.enterd10digitreferalcode = '';
      $("#refrralMsg").hide();
      $("#changeReferralCodeBtn").attr("disabled", false);
      this.referralCode = "";
      this._loginService.checkReferralCode(referralcode).subscribe((reponse) => {
        if (reponse == 'Vaild Referral Code') {
          this.referralCode = reponse;
          return false
        } else {
          this.referralCode = reponse;
          // return true
          this.changeReferralCode(referralcode);
          $('#changeReferralCodeBtn').focus();

        }
      }, err => {
        alert(err)
      });
    } else {
      this.enterdminlenght = "less";
      $("#refrralMsg").toggle();
      this.referralCode = '';
      this.enterd10digitreferalcode = '';
      $("#changeReferralCodeBtn").attr("disabled", true);
      return false

    }

  }
  changeMobileNoMobileEnter() {
    $('#otpchangemobileno').focus();
  }
  changeMobileNoOtpEnter(mobileno, otp) {
    if (otp != '') {
      this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {

        if (response === 'Otp Not Match' || response === 'Expired Otp') {
          //  alert("Otp Not Match")
          this.otpCheck = response;
          info_noti("Otp Not Match");

        } else {
          this.changeMobileNo(mobileno);
          $('#changemobilenobtn').focus();
        }

      }, error => {

      });
    }
  }





  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    $("#planExpireModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#subscriptionModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#choosePlanModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#choosePlanModelforExpire").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#changeReferralCodeModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#changeMobileNoModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();


    $("#changeProfilePicModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#shareusModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#DeclineConfirmModalDeletePrfilePic").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
  }

  loadHealtCardBakSideForm() {
    debugger;
    this.isHealthCardBackSideForm = true;
    this.hcBackSideForm = this.formBuilder.group({
      'scanqrcode': ['Scan QR Code'],
      'qrcodelogo': ['https://mdhl.s3.ap-south-1.amazonaws.com/mdhlQrCode.png'],
      'or': ['OR'],
      'visit': ['Visit app.mdhl.in'],
      'issuedby': ['Health Card issued by'],
      'poweredby': [' EasyReach Healthcare Private Limited'],
      'callus': ['Call Us:+918433513351 (Mon-Fri):10.00 AM-06.00 PM (IST)'],
      'hcRefferalText': [null, Validators.required],
      'hcBackSideText': [null, Validators.required],
    })

  }



  // healthCardIssue(event){
  //   this.HealthCardText=event.target.value;
  // }

  changeHealthCardIssueRefferalText(form: NgForm) {
    debugger;
    if (this.hcBackSideForm.get("hcRefferalText").value == "") {
      info_noti("Please Entered HealthCard Refferal Text")
      // $("#addHealthCardReferalTextModal").modal("hide");
      // $('body').removeClass('modal-open');
      // $('.modal-backdrop').remove();

    } else {
      this.doctorservice.updateHealthCardRefferalText(this.loggedUserInfo.user_reg_id, this.hcBackSideForm.value).subscribe(response => {
        this.isHealthCardBackSideForm = false;
        if (response === "Update HealthCard Issued") {
          info_noti(" Update HealthCard Refferal Text")
          this.HealthCardText = "";

          $("#addHealthCardReferalTextModal").modal("hide");
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove();
          window.location.reload();
        } else {
          info_noti("Not Update HealthCard Refferal Text")
        }



      }, err => {

      });
    }
  }

  clearData(form: NgForm) {
    form.reset();
    // this.HealthCardText = "";
    // $("#healthcardissue").val('');
    $('#display_counthcRefferalText').html(0);
    $('#display_counthcBackSideText').html(0);

  }
  healthCardRefferalText() {
    this.loadHealtCardBakSideForm();
    // $("#healthcardissue").val("this.loggedUserInfo.healthCardIssueReferalText");
    // alert(this.loggedUserInfo.healthCardIssueReferalText)
    this.hcBackSideForm.get("hcRefferalText").setValue(this.loggedUserInfo.healthCardIssueReferalText);
    this.hcBackSideForm.get("hcBackSideText").setValue(this.loggedUserInfo.healthCardBackSideText);

    // $("#healthcardissue").val(this.loggedUserInfo.healthCardIssueReferalText);
    if (this.loggedUserInfo.healthCardIssueReferalText !== null) {
      $('#display_counthcRefferalText').html(this.loggedUserInfo.healthCardIssueReferalText.length);
    }
    if (this.loggedUserInfo.healthCardBackSideText !== null) {
      $('#display_counthcBackSideText').html(this.loggedUserInfo.healthCardBackSideText.length);
    }

  }
  deleteHealthCardIssedBy() {
    this.HealthCardText = "";
    this.doctorservice.updateHealthCardRefferalText(this.loggedUserInfo.user_reg_id, this.HealthCardText).subscribe(response => {
      if (response === "Update HealthCard Issued") {
        info_noti(" Update HealthCard Refferal Text")
        this.HealthCardText = "";

        $("#healthcardissue").val('');
        $("#addHealthCardReferalTextModal").modal("hide");
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();


        $("#DeclineConfirmModal").modal("hide");
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        window.location.reload();
      } else {
        info_noti("Not Update HealthCard Refferal Text")
      }
    }, err => {

    });
  }
  wordCount(type, field, maxlimit) {
    if (field == 'hcRefferalText') {
      var value = $('#hcRefferalText').val();
      if (value.length == 0) {
        $('#display_counthcRefferalText').html(0);

        return;
      }
      var charCount = value.length;
      $('#display_counthcRefferalText').html(charCount);
    }
    if (field == 'hcBackSideText') {
      var value = $('#hcBackSideText').val();

      if (value.length == 0) {
        $('#display_counthcBackSideText').html(0);

        return;
      }
      var charCount = value.length;
      $('#display_counthcBackSideText').html(charCount);


    }





  }

  planClick() {
    this.getPlanList();

  }

  loadHealthCardTypeFormForPlan() {
    this.healthCardTypeFormForPlan = this.formBuilder.group({
      'radioBtnHCType': ['LaminatedHealthCard',],

    });
  }



  choosePlanRadioBtn(event, data) {
    debugger;
    this.currentRow = data.plan_id;
    this.disableSubcriptionbutton = true;
    this.radioBtnId = event.value;
    this.planChooseData = data;


  }


  noPromoCodeClick() {
    debugger;
    $("#promoCodeModel").modal("hide");
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.promoCodeYes = false;
    this.loadHealthCardTypeFormForPlan();
    this.planClick();
    // $("#laminatedhealthcard").attr('checked', 'checked');
    // $('#laminatedhealthcard').prop('checked', true);

    this.updatePlanRequestDto.registrationCharges = this.mdhlSettingInfo.registartionCharges;
    this.updatePlanRequestDto.healthCardCharges = this.mdhlSettingInfo.laminatedHealthCard;
    this.updatePlanRequestDto.healthCardType = "Laminated health card";
    this.healthCardChargespayment = this.mdhlSettingInfo.laminatedHealthCard;
    this.healthCardType = "Laminated health card";
  }
  promoCodeYesClick() {
    this.promoCodeYes = true;
    this.loadPromoCodeForm();
  }
  promoCodeCloseClick(form: NgForm) {
    this.promoCodeYes = false;
    form.reset();
  }
  loadPromoCodeForm() {
    debugger;
    this.promoCodeForm = this.formBuilder.group({
      'promoCodeName': [null, Validators.required],
    })

  }

  applyPromoCode(form: NgForm) {

    if (this.promoCodeForm.invalid) {
      return;
    }
    this.promCodeService.checkPromCode(this.promoCodeForm.value, this.loggedUserInfo.user_reg_id).subscribe(res => {

      console.log(res);
      Object.assign(this.promoCode, res);


      this._loginService.userUpdatePlanWithPromoCode(this.loggedUserInfo.user_reg_id, this.promoCode.promocodeId).subscribe(paymentres => {
        form.reset();
        this.paymentData = paymentres;
        this.promoCodeSubmit(paymentres);

      }, err => {

      });

      // this.planDataService.GetPlanById(this.promoCode.plan).subscribe(planres=>{
      //   $("#promoCodeModel").modal("hide");
      //   $("body").removeClass('modal-open');
      //   $('.modal-backdrop').remove();
      // this.promoCodeSubmit(this.promoCode,planres);
      //   form.reset();
      // },err=>{

      // });
    }, err => {

      info_noti(err.error)


    })

  }


  promoCodeSubmit(payment: PaymentDetails) {
    $("#promoCodeModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#transactionModal").modal("show");
    this.payuform.firstname = payment.name;
    this.payuform.phone = payment.phone;
    this.payuform.productinfo = payment.productinfo;
    this.payuform.email = payment.email;
    this.payuform.planid = payment.planid;
    this.payuform.userid = this.loggedUserInfo.user_reg_id;
    this.payuform.promocodeid = payment.promocodeid;
    this.payuform.amount = payment.amount;
    this.payuform.healthCardType = payment.healthCardType;


    this.payuform.discountType = payment.discountType;
    this.payuform.discount = payment.discount;
 
    this.payuform.healthCardCharges = payment.healthCardCharges;
    this.payuform.registrationCharges = payment.registrationCharges;
    this.payuform.gstAmount = payment.gstAmount;
    this.payuform.basicamount = payment.basicamount;
    this.payuform.gstper = payment.gstper;
    
    this.payuform.previousPlanData = payment.previousPlanData;
    this.payuform.currentPlanData = payment.currentPlanData;
    this.payuform.amountPerMB = payment.amountPerMB;
    
    this.payuform.planData = payment.planData;
    this.payuform.planExpireDate = payment.planExpireDate;
    this.payuform.dataAndAmount = payment.dataAndAmount;

    this.confirmPayment();
  }

  public payuform: PaymentDetails = new PaymentDetails();
  disablePaymentButton: boolean = true;
  Add_CloseClick() {
    debugger;
    this.paymentData = new PaymentDetails();
    this.payuform = new PaymentDetails();
    this.updatePlanRequestDto = new updatePlanRequestDto();
    this.currentRow = 0;
    this.pymentBackBtn = false;
    this.promoCodeYes = false;
    this.disableSubcriptionbutton = false;
    this.healthCardChargespayment;
    this.healthCardType;
    $('#laminatedhealthcard').prop("checked", true);


  }
  confirmPayment() {
    const paymentPayload = {
      email: this.payuform.email,
      name: this.payuform.firstname,
      phone: this.payuform.phone,
      productinfo: this.payuform.productinfo,
      amount: this.payuform.amount,
      userid: this.payuform.userid,
      planid: this.payuform.planid,
      promocodeid: this.payuform.promocodeid,
      healthCardType: this.payuform.healthCardType,

      discountType: this.payuform.discountType,
      discount: this.payuform.discount,
      healthCardCharges: this.payuform.healthCardCharges,
      registrationCharges: this.payuform.registrationCharges,
      gstAmount: this.payuform.gstAmount,
      basicamount: this.payuform.basicamount,
      gstper: this.payuform.gstper,
      previousPlanData :this.payuform.previousPlanData,
      currentPlanData: this.payuform.currentPlanData,
      amountPerMB: this.payuform.amountPerMB,
      planData: this.payuform.planData,
      planExpireDate: this.payuform.planExpireDate,
      dataAndAmount: this.payuform.dataAndAmount,

    }

    console.log(paymentPayload);
    debugger;
    this._paymentService.paymentDetails(paymentPayload).subscribe(
      data => {
        console.log(data);
        this.payuform.txnid = data.txnid;
        this.payuform.surl = data.surl;
        this.payuform.furl = data.furl;
        this.payuform.key = data.key;
        this.payuform.hash = data.hash;
        this.payuform.service_provider = "payu_paisa";
        this.disablePaymentButton = false;
        // this.pymentBackBtn = false;
        this.promoCodeYes = false;
        // this.disableSubcriptionbutton=false;
      }, error1 => {
        console.log(error1);
      })

  }
  payuformSubmitBtn() {
    debugger;
    this.currentRow = 0;
    this.disableSubcriptionbutton = false;
    this.healthCardChargespayment;
    this.healthCardType;
    $('#laminatedhealthcard').prop("checked", true);
  }
  choosePlanDataCloseClick() {
    debugger;
    $('#laminatedhealthcard').prop("checked", true);
    this.currentRow = 0;
    this.disableSubcriptionbutton = false;


  }

  addSubscribePlan() {
    debugger;
    this.pymentBackBtn = true;
    console.log(this.planChooseData);
    $("#choosePlanModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
    $("#transactionModal").modal("show");


    this.updatePlanRequestDto.planid = this.planChooseData.plan_id;
    this.updatePlanRequestDto.userid = this.loggedUserInfo.user_reg_id;

    this._loginService.userUpdatePlanWithOutPromoCode(this.updatePlanRequestDto).subscribe(paymentres => {
      // this.updatePlanRequestDto = new updatePlanRequestDto();
      this.paymentData = paymentres;
      $("#transactionModal").modal("show");
      this.payuform.firstname = paymentres.name;
      this.payuform.phone = paymentres.phone;
      this.payuform.productinfo = paymentres.productinfo;
      this.payuform.email = paymentres.email;
      this.payuform.planid = paymentres.planid;
      this.payuform.userid = paymentres.userid;
      this.payuform.promocodeid = paymentres.promocodeid;
      this.payuform.amount = paymentres.amount;
      this.payuform.healthCardType = paymentres.healthCardType;

    
      this.payuform.discountType = paymentres.discountType;
      this.payuform.discount = paymentres.discount;
   
      this.payuform.healthCardCharges = paymentres.healthCardCharges;
      this.payuform.registrationCharges = paymentres.registrationCharges;
      this.payuform.gstAmount = paymentres.gstAmount;
      this.payuform.basicamount = paymentres.basicamount;
      this.payuform.gstper = paymentres.gstper;
      
      this.payuform.previousPlanData = paymentres.previousPlanData;
      this.payuform.currentPlanData = paymentres.currentPlanData;
      this.payuform.amountPerMB = paymentres.amountPerMB;
      
      this.payuform.planData = paymentres.planData;
      this.payuform.planExpireDate = paymentres.planExpireDate;
      this.payuform.dataAndAmount = paymentres.dataAndAmount;

      this.confirmPayment();
    })
  }

  paymentBack() {
    debugger;
    $("#transactionModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
    $("#choosePlanModel").modal("show");
    // this.currentRow = 0;
    // this.disableSubcriptionbutton = false;



  }

  healthCardChargesRBtn(event) {
    debugger
    if (event.value === "LaminatedHealthCard") {
      this.updatePlanRequestDto.healthCardType = "Laminated health card";
      this.updatePlanRequestDto.healthCardCharges = this.mdhlSettingInfo.laminatedHealthCard;
      this.healthCardChargespayment = this.mdhlSettingInfo.laminatedHealthCard;
      this.healthCardType = "Laminated health card";

    } else if (event.value === "PlasticlaminatedHealthCard") {
      this.updatePlanRequestDto.healthCardType = "Plastic laminated health card";
      this.updatePlanRequestDto.healthCardCharges = this.mdhlSettingInfo.plasticLaminatedHelathCard;

      this.healthCardChargespayment = this.mdhlSettingInfo.plasticLaminatedHelathCard;
      this.healthCardType = "Plastic laminated health card";

    } else if (event.value === "None") {
      this.updatePlanRequestDto.healthCardType = "None";
      this.updatePlanRequestDto.healthCardCharges = 0;

      this.healthCardChargespayment = 0;
      this.healthCardType = "None";
    }

  }

  planExpiredChoosePlan(status) {
    if (status == "ExpirePlan") {
      this.planExpire = true;
    } else if (status == "PlanWillExpire") {
      this.planExpire = false;
    }
  }

  healthCardCharges() {

    this.pymentBackBtn = true;
    $("#choosePlanModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
    $("#transactionModal").modal("show");


    var healthCardChargesRequestDto = {
      'userid': this.loggedUserInfo.user_reg_id,
      'healthCardCharges': this.healthCardChargespayment,
      'healthCardType': this.healthCardType,

    }

    this._loginService.userGetHealthCard(healthCardChargesRequestDto).subscribe(paymentres => {
      this.paymentData = paymentres;
      $("#transactionModal").modal("show");
      this.payuform.firstname = paymentres.name;
      this.payuform.phone = paymentres.phone;
      this.payuform.productinfo = paymentres.productinfo;
      this.payuform.email = paymentres.email;
      this.payuform.planid = paymentres.planid;
      this.payuform.userid = paymentres.userid;
      this.payuform.promocodeid = paymentres.promocodeid;
      this.payuform.amount = paymentres.amount;
      this.payuform.healthCardType = paymentres.healthCardType;
      this.payuform.gstAmount = paymentres.gstAmount;
      this.payuform.gstper = paymentres.gstper;
      this.payuform.healthCardCharges = paymentres.healthCardCharges;
      debugger;
      this.confirmPayment();

    });
  }
  amountZeroSubmit() {
    this._loginService.userUpdatePlanWithPromoCodeAmountZero(this.loggedUserInfo.user_reg_id, this.promoCode.promocodeId).subscribe(res => {
      this.promoCode = new PromoCode();
      $("#transactionModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
      this.promoCodeYes = false;
      info_noti(res);
      window.location.reload();
    });


  }


  //CK Editor

  previewHealthCardBackSide(healthcard) {
    debugger;
    this.healthCardBackSidePreviewObj = this.hcBackSideForm.value;
    console.log(this.healthCardBackSidePreviewObj);
  }
  previewHealthCardBakSideClearData() {
    $("#previewHealthCardBackSideModal").modal("hide");

    this.healthCardBackSidePreviewObj = null;

  }
  onPasteCkEditor(event) {
    console.log("Editor Text" + this.hcBackSideForm.get('hcBackSideText').value);

  }
  onChangeCkEditor(event) {
    console.log("Editor Text" + this.hcBackSideForm.get('hcBackSideText').value);
  }
  // printDiv(){
  //   var printContents = document.getElementById('topdiv').innerHTML;
  //   var originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }


  printDiv() {
    let printContents, popupWin;
    printContents = document.getElementById('topdiv').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
       
          <style>
        
/* Health Card css */
.td{
  word-wrap:break-word; 
}
td.tdnormalfontwithleft{
  text-align: left;
  padding: 0px;
  font-family: 'Times New Roman';
  font-size:12px;
}
td.tdboldfontwithcenter{
  text-align: center;
  padding: 0px;
  font-family: 'Times New Roman';
  font-weight:bold;
  font-size:12px;
}
td.tdnormalfontwithcenter{
  text-align: center;
  padding: 0px;
  font-family: 'Times New Roman';
  font-size:12px;
}

.divsizehealthhistory{
  width: 310px;
  height:60px; 
  overflow: hidden !important;

}
.divsizehealthcardbackside{
  display: block; 
  height:71px; 
  overflow: hidden !important;
}
p.healthcardparagraph{
  margin-bottom: 0px;
}

.lefttable{
  width: 320px;
  height: 204px;
  border: 1px
  word-wrap:break-word; 
}

.maintable{
  table-layout: fixed;
   width: 320px;
  height: 204px;
  // width: 640px;
  // height: 204px;
  }

  table.bordertable{
    border: 1px solid black;
  }

     
  .watermarkhealthcardimage
{
  width: 100px;
  height: 100px;
/* // width:500px;
// height:250px; */
background:url('../../assets/images/watermark.png');
background-repeat:no-repeat;
background-position:center;


}

.watermarkhealthcard{
  width: 320px;
  height: 204px;
// opacity:0.6;
// filter:alpha(opacity=60);
}

  p{margin:0; padding:0}
        @page {
          size:8.3in 11.7in; 
          margin: .5in .5in .5in .5in; 
          mso-header-margin: .5in; 
          mso-footer-margin: .5in; 
          mso-paper-source: 0;
   }
     
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
}


